let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4y5P7")).then(() => parcelRequire('4W57j'));